"use client";
import React, { FC, useRef, useState } from "react";
import { ShowWhen } from "@/components/common";

type TCopyAddressProps = {
  text: string;
  children: React.ReactNode;
};

const CopyAddress: FC<TCopyAddressProps> = ({ text, children }) => {
  const [visible, setVisible] = useState(false);
  const [copied, setCopied] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  const handleCopy = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        setCopied(false);
        setVisible(false);
      }, 2000);
    });
    setVisible(true);
  };

  return (
    <div className="relative inline-block cursor-pointer">
      <div onClick={handleCopy} className="inline-block">
        {children}
      </div>
      <ShowWhen condition={visible}>
        <div className="absolute z-10 -mt-2 w-fit rounded bg-[#f9f9f9] p-2 text-sm text-black shadow-lg">
          <p> {copied && "Copied!"}</p>
        </div>
      </ShowWhen>
    </div>
  );
};

export { CopyAddress };
